import { Breadcrumbs, Typography } from '@mui/material';
import NextLink from 'next/link';

import styles from '../../styles/Breadcrumbs.module.scss';

const BreadcrumbsComp = ({ mainPage, typo, variant = 'default' }) => (
  <Breadcrumbs
    className={
      variant === 'default' ? styles.breadcrumbs : styles.breadCrumbsOnas
    }
  >
    {mainPage && (
      <Typography className={styles.typo}>
        <NextLink href={'/'}>STRONA GŁÓWNA</NextLink>
      </Typography>
    )}

    {Array.isArray(typo) ? (
      typo.map((el, idx) =>
        el.url ? (
          <Typography
            key={idx + el}
            className={variant === 'default' ? styles.typo : styles.typoOnas}
          >
            <NextLink href={el.url}>{el.name}</NextLink>
          </Typography>
        ) : (
          el.name && (
            <Typography
              key={idx + el}
              className={variant === 'default' ? styles.typo : styles.typoOnas}
            >
              {el.name}
            </Typography>
          )
        )
      )
    ) : (
      <Typography
        className={variant === 'default' ? styles.typo : styles.typoOnas}
      >
        {typo}
      </Typography>
    )}
  </Breadcrumbs>
);

export default BreadcrumbsComp;
